import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Info } from 'lucide-react'

export default function EventResultsPublicationNotice({ publicationStatus }) {
  if (!publicationStatus.isPartiallyPublished) return null

  const { availableCount, totalCount } = publicationStatus

  return (
    <Alert className="mt-5 border-neutral-blue-600 bg-neutral-blue-800 text-shades-0 [&>svg]:text-neutral-blue-200">
      <Info className="size-4" aria-hidden="true" />
      <AlertTitle>More results are pending</AlertTitle>
      <AlertDescription className="text-neutral-blue-200">
        Results are available for {availableCount} of {totalCount} sessions.
        Remaining results will appear when published.
      </AlertDescription>
    </Alert>
  )
}
